export default __webpack_public_path__ + "static/media/economics-icon.25f5b419.webp";